import React, { FC, ReactNode } from "react";
import classNames from "classnames";
import { View } from "@tarojs/components";
import Mask, { MaskProps } from "../Mask";
// import Activityindicator from "../ActivityIndicator";
import { XHComponentCommonProps } from "../../types";
import "./index.scss";

export type LoadingProps = {
  mask?: MaskProps["mask"];
  color?: string;
  tip?: string | ReactNode;
  size?: number;
} & XHComponentCommonProps;

const Loading: FC<LoadingProps> = ({
  mask,
  className,
  tip = "加载中",
  // color = "#FFF",
  // size = 60,
}) => {
  const cls = classNames("xh-loading", className);

  return (
    <View className={cls}>
      <Mask mask={mask} />
      <View className={classNames("xh-loading-main", { hasTip: tip })}>
        {/* <Activityindicator
          size={size}
          style={{
            "--loading-border-color": color,
            "--loading-border-width": "3px",
          }}
        /> */}
        <View className="xh-loading-main-gif"></View>
        {/* <Image src={require('../../assets/images/loading.gif')} className="xh-loading-main-gif" /> */}

        {/* <View className="xh-loading-main-spinner">
          {[...Array(12).keys()].map((index) => (
            <View
              className={classNames(
                "xh-loading-main-spinner-circle",
                `is-circle${index + 1}`
              )}
              key={`spinner${index}`}
            >
              <View
                className="dot-rotate"
                style={{ backgroundColor: color }}
              ></View>
            </View>
          ))}
        </View> */}
        {tip && <View className="xh-loading-main-tip">{tip}</View>}
      </View>
    </View>
  );
};

export default Loading;
